// A0 - Ünite 1: Alfabe, Sesler & Havacılık Alfabesi
// Hedef: İngilizce alfabesi, telaffuz ve NATO/ICAO fonetik alfabesi

export const A0_UNIT_1 = {
  'A0-U1-L1': {
    id: 'A0-U1-L1',
    title: 'İngilizce Alfabesi ve Telaffuz',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 İngilizce Alfabesi',
          explanation: 'İngilizce alfabesinde 26 harf vardır. Her harfin bir adı ve sesi vardır.',
          table: {
            headers: ['Harf', 'Okunuşu', 'Ses', 'Örnek'],
            rows: [
              ['A a', 'ey /eɪ/', '/æ/ veya /eɪ/', 'apple, name'],
              ['B b', 'bi /biː/', '/b/', 'book, cabin'],
              ['C c', 'si /siː/', '/k/ veya /s/', 'cat, city'],
              ['D d', 'di /diː/', '/d/', 'door, delay'],
              ['E e', 'i /iː/', '/e/ veya /iː/', 'exit, emergency'],
              ['F f', 'ef /ef/', '/f/', 'flight, fasten'],
              ['G g', 'ci /dʒiː/', '/g/ veya /dʒ/', 'gate, gentle'],
              ['H h', 'eyç /eɪtʃ/', '/h/', 'hello, help'],
              ['I i', 'ay /aɪ/', '/ɪ/ veya /aɪ/', 'in, pilot'],
              ['J j', 'cey /dʒeɪ/', '/dʒ/', 'jet, journey'],
              ['K k', 'key /keɪ/', '/k/', 'key, check'],
              ['L l', 'el /el/', '/l/', 'land, luggage'],
              ['M m', 'em /em/', '/m/', 'meal, member']
            ]
          }
        },
        {
          type: 'grammar',
          title: '📚 Alfabe (Devam)',
          table: {
            headers: ['Harf', 'Okunuşu', 'Ses', 'Örnek'],
            rows: [
              ['N n', 'en /en/', '/n/', 'number, name'],
              ['O o', 'ou /əʊ/', '/ɒ/ veya /əʊ/', 'on, open'],
              ['P p', 'pi /piː/', '/p/', 'pilot, passenger'],
              ['Q q', 'kyu /kjuː/', '/kw/', 'queue, question'],
              ['R r', 'ar /ɑːr/', '/r/', 'row, ready'],
              ['S s', 'es /es/', '/s/ veya /z/', 'seat, safety'],
              ['T t', 'ti /tiː/', '/t/', 'take, turbulence'],
              ['U u', 'yu /juː/', '/ʌ/ veya /juː/', 'up, uniform'],
              ['V v', 'vi /viː/', '/v/', 'vest, visa'],
              ['W w', 'dablyu /ˈdʌbljuː/', '/w/', 'window, welcome'],
              ['X x', 'eks /eks/', '/ks/', 'exit, x-ray'],
              ['Y y', 'vay /waɪ/', '/j/ veya /aɪ/', 'yes, fly'],
              ['Z z', 'zed /zed/', '/z/', 'zone, zero']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Amerikan İngilizcesinde Z harfi "zi" /ziː/ olarak okunur.'
        },
        {
          type: 'vocabulary',
          title: '✈️ Havacılık Kelimeleri',
          words: [
            { en: 'alphabet', tr: 'alfabe', pronunciation: '/ˈælfəbet/' },
            { en: 'spell', tr: 'hecelemek', pronunciation: '/spel/' },
            { en: 'pronounce', tr: 'telaffuz etmek', pronunciation: '/prəˈnaʊns/' },
            { en: 'letter', tr: 'harf', pronunciation: '/ˈletər/' },
            { en: 'sound', tr: 'ses', pronunciation: '/saʊnd/' }
          ]
        }
      ],
      exercises: [
        {
          type: 'matching',
          instruction: 'Harfleri okunuşlarıyla eşleştirin',
          pairs: [
            { left: 'A', right: 'ey' },
            { left: 'E', right: 'i' },
            { left: 'I', right: 'ay' },
            { left: 'O', right: 'ou' },
            { left: 'U', right: 'yu' }
          ]
        },
        {
          type: 'multipleChoice',
          question: '"G" harfi nasıl okunur?',
          options: ['gi', 'ci', 'key', 'cey'],
          correctIndex: 1,
          explanation: 'G harfi İngilizcede "ci" /dʒiː/ olarak okunur.'
        },
        {
          type: 'multipleChoice',
          question: '"W" harfinin okunuşu hangisidir?',
          options: ['vi', 'dablyu', 'vay', 'yu'],
          correctIndex: 1,
          explanation: 'W harfi "double u" yani "dablyu" olarak okunur.'
        },
        {
          type: 'dragDrop',
          instruction: 'Harfleri alfabetik sıraya dizin',
          words: ['D', 'B', 'A', 'C', 'E'],
          correctOrder: [2, 1, 3, 0, 4],
          translation: 'A - B - C - D - E'
        },
        {
          type: 'flashcard',
          title: '🎴 Alfabe Kartları',
          cards: [
            { front: 'A', back: 'ey /eɪ/' },
            { front: 'B', back: 'bi /biː/' },
            { front: 'C', back: 'si /siː/' },
            { front: 'D', back: 'di /diː/' },
            { front: 'E', back: 'i /iː/' }
          ]
        }
      ]
    }
  },

  'A0-U1-L2': {
    id: 'A0-U1-L2',
    title: 'Sesli Harfler (Vowels)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Sesli Harfler (Vowels)',
          explanation: 'İngilizcede 5 sesli harf vardır: A, E, I, O, U. Bu harfler kelimelerde farklı sesler çıkarır.',
          formula: 'Sesli Harfler = A, E, I, O, U'
        },
        {
          type: 'grammar',
          title: '🔊 Sesli Harflerin Sesleri',
          table: {
            headers: ['Harf', 'Kısa Ses', 'Örnek', 'Uzun Ses', 'Örnek'],
            rows: [
              ['A', '/æ/', 'cat, bag', '/eɪ/', 'name, gate'],
              ['E', '/e/', 'bed, exit', '/iː/', 'be, she'],
              ['I', '/ɪ/', 'sit, in', '/aɪ/', 'I, pilot'],
              ['O', '/ɒ/', 'hot, on', '/əʊ/', 'go, open'],
              ['U', '/ʌ/', 'up, but', '/juː/', 'use, uniform']
            ]
          }
        },
        {
          type: 'example',
          title: '✈️ Havacılık Örnekleri',
          items: [
            { en: 'AISLE (koridor)', note: 'A = /aɪ/ uzun ses' },
            { en: 'EXIT (çıkış)', note: 'E = /e/ kısa ses' },
            { en: 'PILOT (pilot)', note: 'I = /aɪ/ uzun ses' },
            { en: 'BOARDING (biniş)', note: 'O = /ɔː/ uzun ses' },
            { en: 'UNIFORM (üniforma)', note: 'U = /juː/ uzun ses' }
          ]
        },
        {
          type: 'tip',
          content: '💡 "A" ve "AN" kullanımı: Sesli harfle başlayan kelimelerden önce "AN", sessiz harfle başlayanlardan önce "A" kullanılır. AN exit, A gate'
        }
      ],
      exercises: [
        {
          type: 'fillBlank',
          instruction: 'Boşlukları uygun sesli harfle doldurun',
          sentences: [
            { text: 'P_LOT (pilot)', answer: 'I', hint: 'Uzun /aɪ/ sesi' },
            { text: 'S__T (koltuk)', answer: 'EA', hint: 'seat kelimesi' },
            { text: 'FL_GHT (uçuş)', answer: 'I', hint: 'Uzun /aɪ/ sesi' },
            { text: 'G_TE (kapı)', answer: 'A', hint: 'Uzun /eɪ/ sesi' }
          ]
        },
        {
          type: 'multipleChoice',
          question: 'Hangisi sesli harf DEĞİLDİR?',
          options: ['A', 'E', 'B', 'O'],
          correctIndex: 2,
          explanation: 'B sessiz bir harftir. Sesli harfler: A, E, I, O, U'
        }
      ]
    }
  },

  'A0-U1-L3': {
    id: 'A0-U1-L3',
    title: 'NATO/ICAO Fonetik Alfabesi',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 NATO/ICAO Fonetik Alfabesi',
          explanation: 'Havacılıkta telsiz iletişiminde harflerin karışmaması için fonetik alfabe kullanılır. Her harf için standart bir kelime vardır.',
          table: {
            headers: ['Harf', 'Kod Kelime', 'Okunuşu'],
            rows: [
              ['A', 'ALPHA', 'AL-FAH'],
              ['B', 'BRAVO', 'BRAH-VOH'],
              ['C', 'CHARLIE', 'CHAR-LEE'],
              ['D', 'DELTA', 'DELL-TAH'],
              ['E', 'ECHO', 'ECK-OH'],
              ['F', 'FOXTROT', 'FOKS-TROT'],
              ['G', 'GOLF', 'GOLF'],
              ['H', 'HOTEL', 'HOH-TEL'],
              ['I', 'INDIA', 'IN-DEE-AH'],
              ['J', 'JULIET', 'JEW-LEE-ETT'],
              ['K', 'KILO', 'KEY-LOH'],
              ['L', 'LIMA', 'LEE-MAH'],
              ['M', 'MIKE', 'MIKE']
            ]
          }
        },
        {
          type: 'grammar',
          title: '📚 Fonetik Alfabe (Devam)',
          table: {
            headers: ['Harf', 'Kod Kelime', 'Okunuşu'],
            rows: [
              ['N', 'NOVEMBER', 'NO-VEM-BER'],
              ['O', 'OSCAR', 'OSS-CAR'],
              ['P', 'PAPA', 'PAH-PAH'],
              ['Q', 'QUEBEC', 'KEH-BECK'],
              ['R', 'ROMEO', 'ROW-ME-OH'],
              ['S', 'SIERRA', 'SEE-AIR-RAH'],
              ['T', 'TANGO', 'TANG-GO'],
              ['U', 'UNIFORM', 'YOU-NEE-FORM'],
              ['V', 'VICTOR', 'VIK-TAH'],
              ['W', 'WHISKEY', 'WISS-KEY'],
              ['X', 'X-RAY', 'ECKS-RAY'],
              ['Y', 'YANKEE', 'YANG-KEY'],
              ['Z', 'ZULU', 'ZOO-LOO']
            ]
          }
        },
        {
          type: 'example',
          title: '✈️ Uçuş Kodu Söyleme',
          items: [
            { en: 'TK = Tango Kilo', note: 'Türk Hava Yolları kodu' },
            { en: 'BA = Bravo Alpha', note: 'British Airways kodu' },
            { en: 'LH = Lima Hotel', note: 'Lufthansa kodu' },
            { en: 'AF = Alpha Foxtrot', note: 'Air France kodu' }
          ]
        },
        {
          type: 'tip',
          content: '💡 Kabin memurları telsizde isim veya kod söylerken bu alfabeyi kullanır. Örnek: "Gate B12" = "Gate Bravo One Two"'
        }
      ],
      exercises: [
        {
          type: 'swipeVocabulary',
          title: '🎴 Fonetik Alfabe Kartları - Biliyor musun?',
          cards: [
            { front: 'ALPHA', back: 'A Harfi', phonetic: '/AL-FAH/', example: 'Gate A = Gate Alpha' },
            { front: 'BRAVO', back: 'B Harfi', phonetic: '/BRAH-VOH/', example: 'BA = Bravo Alpha (British Airways)' },
            { front: 'CHARLIE', back: 'C Harfi', phonetic: '/CHAR-LEE/', example: 'Seat 12C = Seat One Two Charlie' },
            { front: 'DELTA', back: 'D Harfi', phonetic: '/DELL-TAH/', example: 'DL = Delta Lima (Delta Airlines)' },
            { front: 'ECHO', back: 'E Harfi', phonetic: '/ECK-OH/', example: 'Row E = Row Echo' },
            { front: 'FOXTROT', back: 'F Harfi', phonetic: '/FOKS-TROT/', example: 'AF = Alpha Foxtrot (Air France)' },
            { front: 'GOLF', back: 'G Harfi', phonetic: '/GOLF/', example: 'Gate G = Gate Golf' },
            { front: 'HOTEL', back: 'H Harfi', phonetic: '/HOH-TEL/', example: 'LH = Lima Hotel (Lufthansa)' },
            { front: 'INDIA', back: 'I Harfi', phonetic: '/IN-DEE-AH/', example: 'AI = Alpha India (Air India)' },
            { front: 'KILO', back: 'K Harfi', phonetic: '/KEY-LOH/', example: 'TK = Tango Kilo (THY)' },
            { front: 'SIERRA', back: 'S Harfi', phonetic: '/SEE-AIR-RAH/', example: 'SK = Sierra Kilo (SAS)' },
            { front: 'TANGO', back: 'T Harfi', phonetic: '/TANG-GO/', example: 'TK = Tango Kilo (THY)' }
          ]
        },
        {
          type: 'matching',
          instruction: 'Harfleri fonetik kodlarıyla eşleştirin',
          pairs: [
            { left: 'A', right: 'Alpha' },
            { left: 'B', right: 'Bravo' },
            { left: 'C', right: 'Charlie' },
            { left: 'T', right: 'Tango' },
            { left: 'K', right: 'Kilo' }
          ]
        },
        {
          type: 'multipleChoice',
          question: '"S" harfinin fonetik kodu nedir?',
          options: ['Sugar', 'Sierra', 'Samuel', 'Solo'],
          correctIndex: 1,
          explanation: 'S harfinin NATO/ICAO fonetik kodu SIERRA\'dır.'
        },
        {
          type: 'speaking',
          instruction: 'TK1234 uçuş kodunu fonetik alfabeyle söyleyin',
          answer: 'Tango Kilo One Two Three Four'
        }
      ]
    }
  },

  'A0-U1-L4': {
    id: 'A0-U1-L4',
    title: 'Hece ve Vurgu (Syllables & Stress)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Hece Nedir?',
          explanation: 'Hece, bir kelimeyi oluşturan ses birimlerdir. Her hecede en az bir sesli harf (vowel) bulunur.',
          examples: [
            'SEAT = 1 hece (seat)',
            'PI-LOT = 2 hece (pi-lot)',
            'PAS-SEN-GER = 3 hece (pas-sen-ger)',
            'E-MER-GEN-CY = 4 hece (e-mer-gen-cy)'
          ]
        },
        {
          type: 'grammar',
          title: '🔊 Vurgu (Stress)',
          explanation: 'İngilizce kelimelerde bir hece diğerlerinden daha güçlü söylenir. Bu vurgulu hecedir. Vurgu yanlış yere yapılırsa kelime anlaşılmaz.',
          table: {
            headers: ['Kelime', 'Heceler', 'Vurgu', 'Doğru Telaffuz'],
            rows: [
              ['PILOT', 'PI-lot', '1. hece', 'PAY-lıt'],
              ['PASSENGER', 'PAS-sen-ger', '1. hece', 'PAS-ın-cır'],
              ['EMERGENCY', 'e-MER-gen-cy', '2. hece', 'i-MÖR-cın-si'],
              ['DEPARTURE', 'de-PAR-ture', '2. hece', 'di-PAR-çır'],
              ['ARRIVAL', 'ar-RI-val', '2. hece', 'ı-RAY-vıl']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Vurgu işareti: Sözlüklerde vurgulu hece (\') işaretiyle gösterilir. Örnek: /pəˈsendʒər/ - vurgu ikinci hecede değil!'
        },
        {
          type: 'vocabulary',
          title: '✈️ Havacılık Kelimelerinde Vurgu',
          words: [
            { en: 'AIRcraft', tr: 'uçak', note: 'Vurgu: 1. hece' },
            { en: 'airPORT', tr: 'havalimanı', note: 'Vurgu: 2. hece' },
            { en: 'TURbulence', tr: 'türbülans', note: 'Vurgu: 1. hece' },
            { en: 'aNNOUNCEment', tr: 'anons', note: 'Vurgu: 2. hece' },
            { en: 'SAFEty', tr: 'güvenlik', note: 'Vurgu: 1. hece' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '"EMERGENCY" kelimesinde vurgu hangi hecededir?',
          options: ['1. hece (E)', '2. hece (MER)', '3. hece (GEN)', '4. hece (CY)'],
          correctIndex: 1,
          explanation: 'Emergency kelimesinde vurgu 2. hecededir: e-MER-gen-cy'
        },
        {
          type: 'multipleChoice',
          question: '"PASSENGER" kelimesi kaç hecelidir?',
          options: ['1', '2', '3', '4'],
          correctIndex: 2,
          explanation: 'PASSENGER = PAS-SEN-GER (3 hece)'
        },
        {
          type: 'matching',
          instruction: 'Kelimeleri hece sayılarıyla eşleştirin',
          pairs: [
            { left: 'seat', right: '1 hece' },
            { left: 'pilot', right: '2 hece' },
            { left: 'departure', right: '3 hece' },
            { left: 'emergency', right: '4 hece' }
          ]
        }
      ]
    }
  },

  'A0-U1-L5': {
    id: 'A0-U1-L5',
    title: 'Uygulama: Uçuş Kodları ve Kapı Numaraları',
    type: 'practice',
    content: {
      sections: [
        {
          type: 'scenario',
          title: '✈️ Senaryo: Uçuş Bilgisi Verme',
          context: 'Kabin memuru olarak yolculara uçuş bilgilerini söylemeniz gerekiyor.',
          dialogues: [
            {
              speaker: 'Yolcu',
              text: 'Excuse me, what is the flight number?',
              translation: 'Affedersiniz, uçuş numarası nedir?'
            },
            {
              speaker: 'Kabin Memuru',
              text: 'This is flight TK1234 - Tango Kilo One Two Three Four.',
              translation: 'Bu TK1234 - Tango Kilo Bir İki Üç Dört uçuşu.'
            },
            {
              speaker: 'Yolcu',
              text: 'Which gate?',
              translation: 'Hangi kapı?'
            },
            {
              speaker: 'Kabin Memuru',
              text: 'Gate B12 - Bravo One Two.',
              translation: 'B12 Kapısı - Bravo Bir İki.'
            }
          ]
        },
        {
          type: 'grammar',
          title: '🔢 Sayıları Söyleme',
          explanation: 'Havacılıkta sayılar tek tek söylenir:',
          examples: [
            '12 = One Two ("twelve" DEĞİL)',
            '34 = Three Four ("thirty-four" DEĞİL)',
            '100 = One Zero Zero',
            '747 = Seven Four Seven'
          ]
        },
        {
          type: 'tip',
          content: '💡 Karışıklığı önlemek için "9" bazen "NINER" olarak söylenir.'
        }
      ],
      exercises: [
        {
          type: 'speaking',
          instruction: 'Aşağıdaki uçuş kodlarını fonetik alfabeyle söyleyin',
          items: [
            { code: 'TK789', answer: 'Tango Kilo Seven Eight Nine' },
            { code: 'BA456', answer: 'Bravo Alpha Four Five Six' },
            { code: 'Gate C5', answer: 'Gate Charlie Five' }
          ]
        },
        {
          type: 'fillBlank',
          instruction: 'Fonetik kodları yazın',
          sentences: [
            { text: 'TK = ___ Kilo', answer: 'Tango' },
            { text: 'Gate B = Gate ___', answer: 'Bravo' },
            { text: 'LH = Lima ___', answer: 'Hotel' }
          ]
        },
        {
          type: 'multipleChoice',
          question: '"Gate A15" nasıl söylenir?',
          options: [
            'Gate Alpha Fifteen',
            'Gate A Fifteen',
            'Gate Alpha One Five',
            'Gate Alfa One Five'
          ],
          correctIndex: 2,
          explanation: 'Havacılıkta sayılar tek tek söylenir ve A harfi "Alpha" olur: Gate Alpha One Five'
        }
      ]
    }
  },

  'A0-U1-EXAM': {
    id: 'A0-U1-EXAM',
    title: '📝 Ünite 1 Sınavı',
    type: 'exam',
    content: {
      timeLimit: 15,
      passingScore: 80,
      questions: [
        {
          type: 'multipleChoice',
          question: 'İngilizce alfabede kaç harf vardır?',
          options: ['24', '25', '26', '27'],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'Hangisi sesli harftir?',
          options: ['B', 'C', 'E', 'F'],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: '"T" harfinin NATO fonetik kodu nedir?',
          options: ['Tiger', 'Tango', 'Tom', 'Texas'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: '"S" harfinin NATO fonetik kodu nedir?',
          options: ['Sam', 'Sugar', 'Sierra', 'Solo'],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: '"PILOT" kelimesinde vurgu hangi hecededir?',
          options: ['1. hece (PI)', '2. hece (LOT)'],
          correctIndex: 0
        },
        {
          type: 'multipleChoice',
          question: 'TK1234 nasıl söylenir?',
          options: [
            'TK twelve thirty-four',
            'Tango Kilo One Two Three Four',
            'Turkey One Two Three Four',
            'TK one thousand two hundred thirty-four'
          ],
          correctIndex: 1
        },
        {
          type: 'fillBlank',
          question: 'Gate B5 = Gate ___ Five',
          answer: 'Bravo'
        },
        {
          type: 'fillBlank',
          question: 'A harfinin fonetik kodu: ___',
          answer: 'Alpha'
        }
      ]
    }
  }
};

export default A0_UNIT_1;
